
<template>
  <div class="outmain ba_f">
    <div class="shuju_title mar_b20">
      <div class="shuju_title_text">
        <span>{{ $t('plugin.appointment.title') }}</span>
      </div>
    </div>
    <div class="flex mar_t20 mar_b20">
      <el-button type="primary" @click="handleEdit('', 'adopt')" size="medium">{{ $t('plugin.appointment.batchArrive') }}</el-button>
      <el-button type="warning" @click="handleEdit('', 'reject')" size="medium">{{ $t('plugin.appointment.batchNotArrive') }}</el-button>
    </div>
    <el-table v-loading="listLoading" :element-loading-text="loadingText" :data="list" stripe style="width: 100%" @selection-change="setSelectRows">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="userName" :label="$t('rider.list.name')"></el-table-column>
      <el-table-column prop="tel" :label="$t('common.contact')"></el-table-column>
      <el-table-column prop="createdAt" :label="$t('plugin.appointment.enrollTime')"></el-table-column>
      <el-table-column :label="$t('plugin.appointment.arriveTime')">
        <template slot-scope="scope">{{ scope.row.state == '2' ? scope.row.arriveAt : '--' }}</template>
      </el-table-column>
      <el-table-column prop="state" :label="$t('plugin.appointment.trainStatus')">
        <template slot-scope="scope">
          <div class="flex" v-if="scope.row.state == '1'">
            <section class="debug-d debug-small" style="background: #2a75ed;"></section>
            <span style="color: #2a75ed;">{{ $t('plugin.appointment.pendingConfirm') }}</span>
          </div>
          <div class="flex" v-if="scope.row.state == '2'">
            <section class="debug-d debug-small" style="background: #67c23a;"></section>
            <span style="color: #67c23a;">{{ $t('plugin.appointment.arrived') }}</span>
          </div>
          <div class="flex" v-if="scope.row.state == '3'">
            <section class="debug-d debug-small" style="background: #fd5500;"></section>
            <span style="color: #fd5500;">{{ $t('plugin.appointment.notArrived') }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.state != '2'">
            <el-button type="text" @click="handleEdit(scope.row, 'adopt')">{{ $t('plugin.appointment.markArrived') }}</el-button>
            <el-button type="text" @click="handleEdit(scope.row, 'reject')">{{ $t('plugin.appointment.markNotArrived') }}</el-button>
          </template>
          <el-button type="text" @click="handleEdit(scope.row, 'reject')">{{ $t('common.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="page.total" :page-size="page.size" :current-page.sync="page.currentPage" @current-change="handleCurrentChange"></el-pagination>
  </div>
</template>
<script>
import { appointmentList, appointmentOperate } from '@/api/plugins';
export default {
  data() {
    return {
      formInline: { page: 1 },
      list: [],
      listLoading: false,
      selectRows: [],
      page: { total: 0, size: 10, currentPage: 1 },
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      appointmentList(this.formInline).then((res) => {
        if (res.code == 1) {
          this.list = res.data;
          this.page.total = res.count;
          this.listLoading = false;
        }
      });
    },
    handleEdit(row, type) {
      const actionMap = { adopt: this.$t('plugin.appointment.markArrived'), reject: this.$t('plugin.appointment.markNotArrived') };
      const text = actionMap[type] || '';
      if (row && row.id) {
        this.$baseConfirm(this.$t('confirm.actionItem', { action: text }), null, async () => {
          const { msg } = await appointmentOperate({ id: row.id, type });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      } else if (this.selectRows.length > 0) {
        const ids = this.selectRows.map((item) => item.id);
        this.$baseConfirm(this.$t('confirm.actionSelected', { action: text }), null, async () => {
          const { msg } = await appointmentOperate({ id: ids, type });
          this.$baseMessage(msg, 'success');
          this.fetchData();
        });
      } else {
        this.$baseMessage(this.$t('common.noRowSelected'), 'error');
      }
    },
    setSelectRows(val) {
      this.selectRows = val;
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.formInline.page = val;
      this.fetchData();
    },
  },
};
</script>
<style lang="sass" scoped>
</style>
